import { categories } from "@/mocks/categories";
import type { Article } from "@/types/content";

export function getCategory(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export function getCategoryName(slug: string) {
  return getCategory(slug)?.name ?? "未分类";
}

export function getCategoryIcon(slug: string) {
  return getCategory(slug)?.icon ?? "ri-article-line";
}

export function getInfoLevelClass(level: string) {
  if (level === "已证实") {
    return "bg-secondary-100 text-secondary-900 border-secondary-300";
  }
  if (level === "已被辟谣") {
    return "bg-primary-100 text-primary-900 border-primary-300";
  }
  return "bg-accent-100 text-accent-900 border-accent-300";
}

export function formatDate(date: string) {
  const [y, m, d] = date.split("-");
  return `${y}年${Number(m)}月${Number(d)}日`;
}

export function getRelated(article: Article, all: Article[], limit = 3) {
  const pool = article.related
    ? all.filter((a) => article.related?.includes(a.id))
    : all.filter((a) => a.category === article.category && a.id !== article.id);
  return pool.slice(0, limit);
}